import React from 'react';

import { Alert, Box } from '@mui/material';
import { useFormikContext } from 'formik';

function FormAlert() {
	const { errors, touched } = useFormikContext<{ [key: string]: string }>();
	const untouchedErrorsKeys = errors
		? Object.keys(errors).filter((errorKey) => !touched[errorKey])
		: [];

	return untouchedErrorsKeys.length > 0 ? (
		<Box marginTop="16px">
			{untouchedErrorsKeys.map((errorKey) => (
				<Alert severity="error" key={errorKey}>
					{errors[errorKey]}
				</Alert>
			))}
		</Box>
	) : null;
}

export default FormAlert;
